<template>
    <ExecutiveAvatar v-if="isExecutive" :executive="entity" :size="size" />
    <CompanyAvatar v-else-if="isCompany" :company="entity" :size="size" />
</template>

<script setup>
import ExecutiveAvatar from '@/components/executives/avatar'
import CompanyAvatar from '@/components/companies/avatar'

import { computed } from 'vue'

const props = defineProps({
    entity: {
        type: Object,
    },
    size: {
        type: String,
        default: 'small',
    },
})

const entityType = computed(() => props.entity?.type)
const isCompany = computed(() => entityType.value === 'Company')
const isExecutive = computed(() => entityType.value === 'Executive')
</script>
